import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-auth-layout',
    templateUrl: './auth-layout.component.html',
    styleUrls: ['./auth-layout.component.scss', '../../app.component.scss'],
    standalone: false
})
export class AuthLayoutComponent {
  @Input() isExistingCustomer: boolean;
  @Input() currentUrl: string;

  strippedLayoutPaths: string[] = [
    '/version',
    '/redirect',
    '/redirect/saml2',
    '/redirect/products',
    '/redirect/loan',
  ];
}
